export default __webpack_public_path__ + "assets/4d0febef68c690cd22eac3ef5cbd1814.jpeg";